export default __webpack_public_path__ + "static/media/Shelf.101b3759.svg";